import React, { useState } from "react";
import "./Referrals.css";
import Plus from "../../../../../assets/images/admin-dashboard/depinfoplus-outline.png";
import CustomTable from "../../../../Components/CustomTable/CustomTable";

const initialReferralsData = [];

const Referrals = () => {
  const [referralsData, setReferralsData] = useState(initialReferralsData);
  const columns = [
    {
      key: "seriel_number",
      title: "Sl. No.",
    },
    {
      key: "friend_name",
      title: "Friend Name",
    },
    {
      key: "friend_email",
      title: "Friend Email",
    },
    {
      key: "phone",
      title: "Phone",
    },
  ];
  return (
    <div className="cltdetails__referrals_page">
      <div className="cltdetails__referrals_contentwrap">
        <div className="cltdetails__referrals_cboxbanner">
          <span>Referrals</span>
          <button className="cltdetails__referrals_adddepbtn">
            <img
              src={Plus}
              alt=""
              className="cltdetails__referrals_adddepbtnicn"
            />{" "}
            Add Referals
          </button>
        </div>
        <CustomTable
          columns={columns}
          headerStyle={{ background: "rgba(93, 95, 239, 0.9)" }}
        />
      </div>
      <div className="cltdetails__referrals_contentbtnwrap">
        <div className="cltdetails__referrals_bottombtns">
          <button className="cltdetails__referrals_bbtnfilled">Submit</button>
          <button className="cltdetails__referrals_bbtnoutlined">Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default Referrals;
